module.exports = __webpack_public_path__ + "static/media/product_sample_4.df1d0f16.avif";